import { render, staticRenderFns } from "./QuadroDadosDetalhamento.vue?vue&type=template&id=cdad0aca"
import script from "./QuadroDadosDetalhamento.vue?vue&type=script&lang=js"
export * from "./QuadroDadosDetalhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports